<template>
    <div class="linked-question-modal">
        <TitleBaseBox :title="data.title" :noButton="true" @close="close">
            <div class="checked-question-wrapper">
                <ul class="question-list scroll-tracker">
                    <li v-for="item in data.question" :key="item.questionId" @mouseover="mouseOnQuestion(item)" @mouseout="mouseOutQuestion">
                        <input
                            class="question-edit-input"
                            @keypress="keyPressHandler"
                            @blur="blurHandle"
                            :class="{ editing: currentId === item.questionId }"
                            v-model="editVal"
                        />
                        <span v-show="currentId !== item.questionId">{{ item.questionText }}</span>
                        <Icon
                            v-if="isEdit"
                            :width="16"
                            :height="18"
                            bgPosition="-77px 0"
                            hoverBgPosition="-77px -22px"
                            class="question-edit-icon"
                            @iconClick="questionEditHandle(item)"
                            v-show="showDeleteBtn && item.questionId === onMouseoverId"
                        />
                        <DeleteIcon class="opr-delete" @iconClick="deleteItem(item)" v-show="showDeleteBtn && item.questionId === onMouseoverId" />
                    </li>
                </ul>
                <div class="linked-question-search">
                    <QuestionSearch class="question-search" @questionSelected="questionSelected" @close="closeQSearch" />
                </div>
            </div>
            <div class="linked-question-button">
                <RoundButton :text="cancelLabel" @btnClick="cancelClick" :cls="cancelCls"></RoundButton>
                <RoundButton :text="confirmLabel" @btnClick="confirmClick"></RoundButton>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import QuestionSearch from "@/views/zhiji/components/questionSearch/QuestionSearch";
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import i18n from "@/i18n";

export default {
    name: "LinkedQuestionModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        DeleteIcon,
        QuestionSearch,
        Icon
    },
    data() {
        return {
            showDeleteBtn: false,
            onMouseoverId: "",
            linkedQuestionId: "",
            currentId: "",
            currentVal: "",
            editVal: "",
            cancelCls: "cancel-btn"
        };
    },
    computed: {
        isEdit() {
            return this.data.unableEdit ? !this.data.unableEdit : true;
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        questionEditHandle(item) {
            this.$nextTick(() => {
                this.currentVal = item.questionText;
                this.editVal = item.questionText;
                this.currentId = item.questionId;

                setTimeout(() => {
                    let input = document.querySelector(".linked-question-modal .question-edit-input");
                    input && input.focus();
                }, 50);
            });
        },
        keyPressHandler() {
            const isEnterKey = event.keyCode === 13;
            isEnterKey && this.emitEditEvent();
        },
        emitEditEvent() {
            const newText = this.zhiji.strTrim(this.editVal);
            const isChanged = newText != this.currentVal;

            newText &&
                isChanged &&
                this.data.question.some(item => {
                    if (item.questionId === this.currentId) {
                        return (item.questionText = newText);
                    }
                });
            this.currentId = "";
        },
        confirmClick() {
            if (this.linkedQuestionId) {
                let questionArray = [];
                let questionIdArray = [];
                this.data.question.map(function(item) {
                    questionArray.push(item.questionText);
                    questionIdArray.push(item.questionId);
                });
                let configData = {};
                configData.questionArray = questionArray;
                configData.questionIdArray = questionIdArray;
                configData.clusterId = this.data.question[0].clusterId;
                configData.linkQuestionId = this.linkedQuestionId;

                this.data.confirm && this.data.confirm.call(null, configData);
                this.close();
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("zhiji.cluster.linkQuestion")
                    }
                });
            }
        },
        deleteItem(item) {
            this.data.question = this.data.question.filter(function(question) {
                return question.questionId !== item.questionId;
            });

            if (this.data.question.length === 0) {
                this.close();
            }
        },
        mouseOnQuestion(item) {
            this.onMouseoverId = item.questionId;
            this.showDeleteBtn = true;
        },
        mouseOutQuestion() {
            this.showDeleteBtn = false;
        },
        questionSelected(data) {
            this.linkedQuestionId = data.questionId;
        },
        closeQSearch() {
            this.isShowSearch = false;
        },
        windowClick(event) {
            if (!!this.currentId && this.zhiji.isClickOuter(event, "scroll-tracker")) {
                this.emitEditEvent();
            }
        },
        blurHandle() {
            this.emitEditEvent();
        }
    }
};
</script>

<style lang="less" scoped>
.editing {
    display: block !important;
}
.linked-question-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .checked-question-wrapper {
        .question-list {
            width: 353px;
            box-shadow: none;
            overflow-y: auto;
            height: 226px;
            background: #ffffff;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
            box-sizing: border-box;
            margin-bottom: 24px;

            li {
                padding: 6px 45px 6px 12px;
                position: relative;
                cursor: pointer;

                .question-edit-input {
                    display: none;
                    width: 90%;
                    margin-right: 10px;
                    border: solid 1px #d8e4f0;
                    box-sizing: border-box;
                    height: 32px;
                    line-height: 32px;
                    border-radius: 4px;
                    &:focus {
                        border-color: #2088f3;
                    }
                }

                span {
                    display: inline-block;
                    vertical-align: top;
                }

                .question-edit-icon {
                    position: absolute;
                    right: 35px;
                    top: 50%;
                    margin-top: -9px;
                }

                .opr-delete {
                    position: absolute;
                    right: 6px;
                    top: 50%;
                    margin-top: -9px;
                }

                &:hover {
                    background: #e4f1f9;
                }
            }

            .on {
                background: #e4f1f9;
            }
        }

        .question-search {
            width: 352px;
        }
    }
    .linked-question-button {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        .cancel-btn {
            background: #fff;
            &:hover {
                color: rgba(65, 71, 94, 0.9) !important;
            }
        }
    }
}
</style>
